export default __webpack_public_path__ + "static/media/approvals.55bebd0c.svg";